import React, { FC } from 'react';
import styled from 'styled-components';

import ProsperCard from '../../assets/icons/prosper-card.svg';
import { FISERV_SIGNIN_URL, MOBILE_BREAKPOINT, colors } from '../constants';

import { PrimaryButton, InlineButton } from './Button';
import Heading from './Heading';
import { ModalWrapper, ModalProps } from './ModalWrapper';

// Styles -----------------------------------------------------------------------------------------
const CompletedApplicationModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border-radius: 0.25rem;
  position: relative;
  padding: 2.5rem 1.5rem 1rem;
  width: 22.75rem;
  @media (max-height: ${MOBILE_BREAKPOINT}) {
    padding: 0;
    width: 33rem;
    max-width: 100%;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 100%;
    padding: 3.25rem 0;
  }
`;
CompletedApplicationModalContent.displayName =
  'CompletedApplicationModalContent';

const ProsperCardIcon = styled(ProsperCard)`
  margin-bottom: 1.75rem;
  @media (max-height: ${MOBILE_BREAKPOINT}) {
    width: 3.0625rem;
    height: 3.25rem;
    margin-bottom: 0.625rem;
  }
`;

const ModalHeading = styled(Heading)`
  margin: 0 1.25rem;
  @media (max-height: ${MOBILE_BREAKPOINT}) {
    margin: 0 0 0.5rem;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin: 0 0.5rem;
  }
`;
ModalHeading.displayName = 'ModalHeading';

// conditional div that allows subtext and phone number on the same line
const SubTextContainer = styled.div`
  margin: 1.25rem 2rem 2.5rem;
  @media (max-height: ${MOBILE_BREAKPOINT}) {
    margin: 0.25rem 0 1rem;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin: 1rem 2.75rem 2.5rem;
  }
`;
SubTextContainer.displayName = 'SubTextContainer';

const SubText = styled.p`
  color: ${colors.TEXT_PRIMARY};
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  text-align: center;
`;
SubText.displayName = 'SubText';

const ContinueButton = styled(PrimaryButton)`
  width: 19rem;
  height: 3.5rem;
  /* margin: 2.125rem 0; */
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 100%;
  }
  @media (max-height: ${MOBILE_BREAKPOINT}) {
    margin: 1rem 0;
  }
`;
ContinueButton.displayName = 'ContinueButton';

const ContinueTextButton = styled(InlineButton)`
  margin: 0;
  width: 4.375rem;
  color: ${colors.TEXT_PRIMARY};
`;
ContinueTextButton.displayName = 'ContinueTextButton';

// Component --------------------------------------------------------------------------------------
export const CompletedApplicationModalControl: FC<ModalProps> = ({
  showModal,
  setShowModal,
}) => {
  const redirectToCompletedApplicationPage = () => {
    // redirect user to their dashboard / Fiserv
    setShowModal(false);
    window.location.href = FISERV_SIGNIN_URL;
  };

  return (
    <ModalWrapper
      showModal={showModal}
      setShowModal={setShowModal}
      disallowClose
      shouldReturnFocusAfterClose={false}
      id="completed-application-modal"
    >
      <CompletedApplicationModalContent>
        <ProsperCardIcon />
        <ModalHeading>
          Looks like you already have the Prosper
          <sup>®</sup> Card
        </ModalHeading>
        <SubTextContainer>
          <SubText>
            Log in to make a payment, check your balance and more
          </SubText>
        </SubTextContainer>
        <ContinueButton
          id="completed-application-modal-continue-button"
          onClick={redirectToCompletedApplicationPage}
          aria-label="Go to your Dashboard"
        >
          Go to your Dashboard
        </ContinueButton>
      </CompletedApplicationModalContent>
    </ModalWrapper>
  );
};
